const warszawaXl = require("../images/Warszawa_2560.png");
const warszawaLg = require("../images/Warszawa_1920.png");
const warszawaMD = require("../images/Warszawa_1366.png");
const warszawaSm = require("../images/Warszawa_600.png");
const warszawaXs = require("../images/Warszawa_300.png");

const wroclawXl = require("../images/Wroclaw_2560.png");
const wroclawLg = require("../images/Wroclaw_1920.png");
const wroclawMd = require("../images/Wroclaw_1366.png");
const wroclawSm = require("../images/Wroclaw_600.png");
const wroclawXs = require("../images/Wroclaw_360.png");

const trojmiastoXl = require("../images/Trojmiasto_2560.png");
const trojmiastoLg = require("../images/Trojmiasto_1920.png");
const trojmiastoMd = require("../images/Trojmiasto_1366.png");
const trojmiastoSm = require("../images/Trojmiasto_600.png");
const trojmiastoXs = require("../images/Trojmiasto_360.png");

const szczecinXl = require("../images/Szczecin_2560.png");
const szczecinLg = require("../images/Szczecin_1920.png");
const szczecinMd = require("../images/Szczecin_1366.png");
const szczecinSm = require("../images/Szczecin_600.png");
const szczecinXs = require("../images/Szczecin_360.png");

const rzeszowXl = require("../images/Rzeszow_2560.png");
const rzeszowLg = require("../images/Rzeszow_1920.png");
const rzeszowMd = require("../images/Rzeszow_1366.png");
const rzeszowSm = require("../images/Rzeszow_600.png");
const rzeszowXs = require("../images/Rzeszow_360.png");

const poznanXl = require("../images/Poznan_2560.png");
const poznanLg = require("../images/Poznan_1920.png");
const poznanMd = require("../images/Poznan_1366.png");
const poznanSm = require("../images/Poznan_600.png");
const poznanXs = require("../images/Poznan_360.png");

const olsztynXl = require("../images/Olsztyn_2560.png");
const olsztynLg = require("../images/Olsztyn_1920.png");
const olsztynMd = require("../images/Olsztyn_1366.png");
const olsztynSm = require("../images/Olsztyn_600.png");
const olsztynXs = require("../images/Olsztyn_360.png");

const lublinXl = require("../images/Lublin_2560.png");
const lublinLg = require("../images/Lublin_1920.png");
const lublinMd = require("../images/Lublin_1366.png");
const lublinSm = require("../images/Lublin_600.png");
const lublinXs = require("../images/Lublin_360.png");

const krakowXl = require("../images/Krakow_2560.png");
const krakowLg = require("../images/Krakow_1920.png");
const krakowMd = require("../images/Krakow_1366.png");
const krakowSm = require("../images/Krakow_600.png");
const krakowXs = require("../images/Krakow_300.png");

const kielceXl = require("../images/Kielce_2560.png");
const kielceLg = require("../images/Kielce_1920.png");
const kielceMd = require("../images/Kielce_1366.png");
const kielceSm = require("../images/Kielce_600.png");
const kielceXs = require("../images/Kielce_360.png");

const katowiceXl = require("../images/Katowice_2560.png");
const katowiceLg = require("../images/Katowice_1920.png");
const katowiceMd = require("../images/Katowice_1366.png");
const katowiceSm = require("../images/Katowice_600.png");
const katowiceXs = require("../images/Katowice_360.png");

const bydgoszczXl = require("../images/Bydgoszcz_2560.png");
const bydgoszczLg = require("../images/Bydgoszcz_1920.png");
const bydgoszczMd = require("../images/Bydgoszcz_1366.png");
const bydgoszczSm = require("../images/Bydgoszcz_600.png");
const bydgoszczXs = require("../images/Bydgoszcz_360.png");

const bialystokXl = require("../images/Bialystok_2560.png");
const bialystokLg = require("../images/Bialystok_1920.png");
const bialystokMd = require("../images/Bialystok_1366.png");
const bialystokSm = require("../images/Bialystok_600.png");
const bialystokXs = require("../images/Bialystok_300.png");

const lodzXl = require("../images/Lodz_2560.png");
const lodzLg = require("../images/Lodz_1920.png");
const lodzMd = require("../images/Lodz_1366.png");
const lodzSm = require("../images/Lodz_600.png");
const lodzXs = require("../images/Lodz_360.png");

const polskaXl = require("../images/Polska_2560.png");
const polskaLg = require("../images/Polska_1920.png");
const polskaMd = require("../images/Polska_1366.png");
const polskaSm = require("../images/Polska_600.png");
const polskaXs = require("../images/Polska_360.png");

export const getHeaderPictures = (citySlug: string | undefined) => {
    switch (citySlug) {
        case "warszawa":
            return {xl: warszawaXl, lg: warszawaLg, md: warszawaMD, sm: warszawaSm, xs: warszawaXs};
        case "wroclaw":
            return {xl: wroclawXl, lg: wroclawLg, md: wroclawMd, sm: wroclawSm, xs: wroclawXs};
        case "gdansk":
            return {xl: trojmiastoXl, lg: trojmiastoLg, md: trojmiastoMd, sm: trojmiastoSm, xs: trojmiastoXs};
        case "szczecin":
            return {xl: szczecinXl, lg: szczecinLg, md: szczecinMd, sm: szczecinSm, xs: szczecinXs};
        case "rzeszow":
            return {xl: rzeszowXl, lg: rzeszowLg, md: rzeszowMd, sm: rzeszowSm, xs: rzeszowXs};
        case "poznan":
            return {xl: poznanXl, lg: poznanLg, md: poznanMd, sm: poznanSm, xs: poznanXs};
        case "olsztyn":
            return {xl: olsztynXl, lg: olsztynLg, md: olsztynMd, sm: olsztynSm, xs: olsztynXs};
        case "lublin":
            return {xl: lublinXl, lg: lublinLg, md: lublinMd, sm: lublinSm, xs: lublinXs};
        case "krakow":
            return {xl: krakowXl, lg: krakowLg, md: krakowMd, sm: krakowSm, xs: krakowXs};
        case "kielce":
            return {xl: kielceXl, lg: kielceLg, md: kielceMd, sm: kielceSm, xs: kielceXs};
        case "katowice":
            return {xl: katowiceXl, lg: katowiceLg, md: katowiceMd, sm: katowiceSm, xs: katowiceXs};
        case "bydgoszcz":
            return {xl: bydgoszczXl, lg: bydgoszczLg, md: bydgoszczMd, sm: bydgoszczSm, xs: bydgoszczXs};
        case "bialystok":
            return {xl: bialystokXl, lg: bialystokLg, md: bialystokMd, sm: bialystokSm, xs: bialystokXs};
        case "lodz":
            return {xl: lodzXl, lg: lodzLg, md: lodzMd, sm: lodzSm, xs: lodzXs};
        default:
            return {xl: polskaXl, lg: polskaLg, md: polskaMd, sm: polskaSm, xs: polskaXs};
    }
};
const warszawaXl = require("../images/Warszawa_2560.png");
const warszawaLg = require("../images/Warszawa_1920.png");
const warszawaMD = require("../images/Warszawa_1366.png");
const warszawaSm = require("../images/Warszawa_600.png");
const warszawaXs = require("../images/Warszawa_300.png");

const wroclawXl = require("../images/Wroclaw_2560.png");
const wroclawLg = require("../images/Wroclaw_1920.png");
const wroclawMd = require("../images/Wroclaw_1366.png");
const wroclawSm = require("../images/Wroclaw_600.png");
const wroclawXs = require("../images/Wroclaw_360.png");

const trojmiastoXl = require("../images/Trojmiasto_2560.png");
const trojmiastoLg = require("../images/Trojmiasto_1920.png");
const trojmiastoMd = require("../images/Trojmiasto_1366.png");
const trojmiastoSm = require("../images/Trojmiasto_600.png");
const trojmiastoXs = require("../images/Trojmiasto_360.png");

const szczecinXl = require("../images/Szczecin_2560.png");
const szczecinLg = require("../images/Szczecin_1920.png");
const szczecinMd = require("../images/Szczecin_1366.png");
const szczecinSm = require("../images/Szczecin_600.png");
const szczecinXs = require("../images/Szczecin_360.png");

const rzeszowXl = require("../images/Rzeszow_2560.png");
const rzeszowLg = require("../images/Rzeszow_1920.png");
const rzeszowMd = require("../images/Rzeszow_1366.png");
const rzeszowSm = require("../images/Rzeszow_600.png");
const rzeszowXs = require("../images/Rzeszow_360.png");

const poznanXl = require("../images/Poznan_2560.png");
const poznanLg = require("../images/Poznan_1920.png");
const poznanMd = require("../images/Poznan_1366.png");
const poznanSm = require("../images/Poznan_600.png");
const poznanXs = require("../images/Poznan_360.png");

const olsztynXl = require("../images/Olsztyn_2560.png");
const olsztynLg = require("../images/Olsztyn_1920.png");
const olsztynMd = require("../images/Olsztyn_1366.png");
const olsztynSm = require("../images/Olsztyn_600.png");
const olsztynXs = require("../images/Olsztyn_360.png");

const lublinXl = require("../images/Lublin_2560.png");
const lublinLg = require("../images/Lublin_1920.png");
const lublinMd = require("../images/Lublin_1366.png");
const lublinSm = require("../images/Lublin_600.png");
const lublinXs = require("../images/Lublin_360.png");

const krakowXl = require("../images/Krakow_2560.png");
const krakowLg = require("../images/Krakow_1920.png");
const krakowMd = require("../images/Krakow_1366.png");
const krakowSm = require("../images/Krakow_600.png");
const krakowXs = require("../images/Krakow_300.png");

const kielceXl = require("../images/Kielce_2560.png");
const kielceLg = require("../images/Kielce_1920.png");
const kielceMd = require("../images/Kielce_1366.png");
const kielceSm = require("../images/Kielce_600.png");
const kielceXs = require("../images/Kielce_360.png");

const katowiceXl = require("../images/Katowice_2560.png");
const katowiceLg = require("../images/Katowice_1920.png");
const katowiceMd = require("../images/Katowice_1366.png");
const katowiceSm = require("../images/Katowice_600.png");
const katowiceXs = require("../images/Katowice_360.png");

const bydgoszczXl = require("../images/Bydgoszcz_2560.png");
const bydgoszczLg = require("../images/Bydgoszcz_1920.png");
const bydgoszczMd = require("../images/Bydgoszcz_1366.png");
const bydgoszczSm = require("../images/Bydgoszcz_600.png");
const bydgoszczXs = require("../images/Bydgoszcz_360.png");

const bialystokXl = require("../images/Bialystok_2560.png");
const bialystokLg = require("../images/Bialystok_1920.png");
const bialystokMd = require("../images/Bialystok_1366.png");
const bialystokSm = require("../images/Bialystok_600.png");
const bialystokXs = require("../images/Bialystok_300.png");

const lodzXl = require("../images/Lodz_2560.png");
const lodzLg = require("../images/Lodz_1920.png");
const lodzMd = require("../images/Lodz_1366.png");
const lodzSm = require("../images/Lodz_600.png");
const lodzXs = require("../images/Lodz_360.png");

const polskaXl = require("../images/Polska_2560.png");
const polskaLg = require("../images/Polska_1920.png");
const polskaMd = require("../images/Polska_1366.png");
const polskaSm = require("../images/Polska_600.png");
const polskaXs = require("../images/Polska_360.png");

export const getHeaderPictures = (citySlug: string | undefined) => {
    switch (citySlug) {
        case "warszawa":
            return {xl: warszawaXl, lg: warszawaLg, md: warszawaMD, sm: warszawaSm, xs: warszawaXs};
        case "wroclaw":
            return {xl: wroclawXl, lg: wroclawLg, md: wroclawMd, sm: wroclawSm, xs: wroclawXs};
        case "gdansk":
            return {xl: trojmiastoXl, lg: trojmiastoLg, md: trojmiastoMd, sm: trojmiastoSm, xs: trojmiastoXs};
        case "szczecin":
            return {xl: szczecinXl, lg: szczecinLg, md: szczecinMd, sm: szczecinSm, xs: szczecinXs};
        case "rzeszow":
            return {xl: rzeszowXl, lg: rzeszowLg, md: rzeszowMd, sm: rzeszowSm, xs: rzeszowXs};
        case "poznan":
            return {xl: poznanXl, lg: poznanLg, md: poznanMd, sm: poznanSm, xs: poznanXs};
        case "olsztyn":
            return {xl: olsztynXl, lg: olsztynLg, md: olsztynMd, sm: olsztynSm, xs: olsztynXs};
        case "lublin":
            return {xl: lublinXl, lg: lublinLg, md: lublinMd, sm: lublinSm, xs: lublinXs};
        case "krakow":
            return {xl: krakowXl, lg: krakowLg, md: krakowMd, sm: krakowSm, xs: krakowXs};
        case "kielce":
            return {xl: kielceXl, lg: kielceLg, md: kielceMd, sm: kielceSm, xs: kielceXs};
        case "katowice":
            return {xl: katowiceXl, lg: katowiceLg, md: katowiceMd, sm: katowiceSm, xs: katowiceXs};
        case "bydgoszcz":
            return {xl: bydgoszczXl, lg: bydgoszczLg, md: bydgoszczMd, sm: bydgoszczSm, xs: bydgoszczXs};
        case "bialystok":
            return {xl: bialystokXl, lg: bialystokLg, md: bialystokMd, sm: bialystokSm, xs: bialystokXs};
        case "lodz":
            return {xl: lodzXl, lg: lodzLg, md: lodzMd, sm: lodzSm, xs: lodzXs};
        default:
            return {xl: polskaXl, lg: polskaLg, md: polskaMd, sm: polskaSm, xs: polskaXs};
    }
};
